<template>
  <div>
    <ul class="tab clearfix">
      <li v-for="(item) in tab" :class="{'active':path == item.pathLink}" @click="onTab(item.pathLink)" :key="item.title">{{item.title}}</li>
    </ul>
    <router-view></router-view>
    <footer-nav :name="nav"></footer-nav>
    <footer-logo></footer-logo>
  </div>
</template>

<script>
  import footerNav from '@/views/footerNav.vue';
  import empty from "@/views/statePage/empty.vue";
  import footerLogo from '@/components/footerLogo.vue';
  export default {
    components: {
      'footer-logo': footerLogo,
      footerNav,
      empty
    },
    data() {
      return {
        path: this.$route.path,
        nav:{
          name:'我的'
        },
        tab: [{
            title: '活动',
            pathLink: '/mine/collect/activity'
          },
          {
            title: '文章',
            pathLink: '/mine/collect/news'
          },
          {
            title: '政知道',
            pathLink: '/mine/collect/policy'
          },
          {
            title: '视频',
            pathLink: '/mine/collect/video'
          },
          {
            title: '产品',
            pathLink: '/mine/collect/project'
          },
        ],
        isEmpty: false,
        defaultImg: 'this.src="' + require("@/assets/images/defaultImg.png") + '"',
      }
    },
    created() {

    },
    watch: {
      '$route'(to, from) {
        this.path = this.$route.path;
      }
    },
    methods: {
      onTab(path) {
        this.$router.push({
          path: path
        });
      },
    }
  };

</script>

<style lang="less" scoped>
  

  #success {
    background: #f7f7f7 !important;
  }

  .tab {
    width: 100%;
    height: 100/@rem-size;
    background: #fff;
    border-bottom: 20/@rem-size solid #f7f7f7;

    li {
      width: 20%;
      height: 100%;
      font-size: 32/@rem-size;
      line-height: 100/@rem-size;
      text-align: center;
      position: relative;
      float: left;

      &.active {
        color: #005fd5;

        &::after {
          content: "";
          display: block;
          width: 88/@rem-size;
          height: 3/@rem-size;
          background: #005fd5;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
        }
      }
    }
  }

</style>
